import { z } from 'zod'

import { m } from '@maestro/commerce-blocks/schemas/helpers'

const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)/

export const passwordField = z
  .string()
  .nonempty(m('password.required'))
  .min(12, m('password.min-length', { min: 12 }))
  .regex(passwordRegex, m('password.requirements'))
  .max(255)
